// Module
var code = "<span ng-switch=\"CommPreferenceEnabledIcon.enabled\"> <dls-icon-circle-check class=\"CommPreferenceEnabledIcon\" ng-switch-when=\"true\"> </dls-icon-circle-check> <dls-icon-circle-x class=\"CommPreferenceEnabledIcon CommPreferenceEnabledIcon--disabled\" ng-switch-default> </dls-icon-circle-x> </span> ";
// Exports
var _module_exports = code;;
var path = '@collectivehealth/frontend-member-v2/pages/settings/commPreferences/commPreferenceEnabledIcon/commPreferenceEnabledIcon.html';
var angular = require('angular');
angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;